module.exports = __webpack_public_path__ + "assets/fdd8088ddc15e1c0b0e0404020a77343.png";